var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPleatsStandard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_4817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8953 12.6472C33.0714 9.69407 42.4096 9.44718 59.7488 12.6472",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8145 58.5625C13.0092 32.5003 12.7227 14.0434 15.1952 10.0972C18.0007 13.9719 19.3663 16.3195 20.6369 21.4908C20.0357 35.6638 19.9671 43.8528 19.9567 58.5625",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6982 58.3927C23.0217 42.462 22.5067 33.9442 20.6372 21.6611",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.365 10.0971C18.9291 7.92267 20.9926 6.7033 29.1393 4.48535",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0002 58.5625C63.8055 32.5003 64.092 14.0434 61.6195 10.0972C58.814 13.9719 57.4484 16.3195 56.1778 21.4908C56.779 35.6638 56.8476 43.8528 56.858 58.5625",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1165 58.3927C53.793 42.462 54.308 33.9442 56.1775 21.6611",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4497 10.0971C57.8856 7.92267 55.8221 6.7033 47.6754 4.48535",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4998 1.08398C29.7881 2.34129 29.4772 3.144 29.1394 4.82516C36.7661 7.08107 40.6489 6.69719 47.6753 4.48506C47.0514 3.07741 46.7096 2.34178 45.6346 1.08398C39.9792 2.61648 36.653 2.59002 30.4998 1.08398Z",
    stroke: "#999999",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_4817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 59,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPleatsStandard);
export default __webpack_public_path__ + "static/media/pleats_standard.2092a0a62b01567c68d74e6f96aac9a4.svg";
export { ForwardRef as ReactComponent };